
import React from 'react';
import { UploadControl } from '@/components/UploadControl';
import { VideoFeatures } from '@/store/videoFeatures';
import { useVideoFeaturesStore } from '@/store/videoFeatures/store';
import { ThumbnailType } from './types';

interface EndThumbnailTabProps {
  features: VideoFeatures;
  handleEndThumbnailUpload: (file: File) => void;
  removeThumbnail: (type: ThumbnailType) => void;
}

export const EndThumbnailTab: React.FC<EndThumbnailTabProps> = ({
  features,
  handleEndThumbnailUpload,
  removeThumbnail,
}) => {
  const setTempFile = useVideoFeaturesStore((state) => state.setTempFile);
  const clearTempFile = useVideoFeaturesStore((state) => state.clearTempFile);

  const handleFileUpload = (file: File) => {
    setTempFile('endThumbnailFile', file);
    handleEndThumbnailUpload(file);
  };

  const handleRemove = (type: ThumbnailType) => {
    clearTempFile('endThumbnailFile');
    removeThumbnail(type);
  };

  return (
    <div className="space-y-6">
      <div className="p-6 bg-white rounded-[14px] border border-[#E2E8F0] shadow-[0_2px_8px_rgba(0,0,0,0.03)]">
        <UploadControl
          label=""
          accept="image/*"
          maxSize={20}
          preview={features.endThumbnail?.imageUrl}
          onFileSelected={handleFileUpload}
          onClear={() => handleRemove('endThumbnail')}
          isActive={features.endThumbnail?.enabled}
        />
      </div>
    </div>
  );
};
